//---------------------
// save current spells
//---------------------
export default function saveCurrentSpells(spells) {
  // -----------------------
  // check got spells array
  // -----------------------
  if (!Array.isArray(spells)) return null
  //--------------------------------------------------
  // create array with specified props for each spell
  //--------------------------------------------------
  const original_spells = spells.map((s) => ({
    
    name: s.name, // spell name for debug only
    // id can be character spell/character item or character rune spell (needed for updates)
    id: s.character_spell_id ? s.character_spell_id : s.character_rune_spell_id ? s.character_rune_spell_id : s.character_item_spell_id ? s.character_item_spell_id : null,
    // for sorcery/divine spells associated with a specific item (NB: any rel between item vs rune spell is thru the character_rune object)
    character_item_id: s.character_item_id ? s.character_item_id : null,
    mag: s.mag,
  
  }))
  return original_spells
}